"use strict";

import "./component.scss";

let listEl = document.querySelectorAll("[data-sr-only-announcer]");

const startListening = (ev) => {
    const announcerHolder = document.getElementById("sr-only-announcer");
    ev.stopPropagation();

    if (ev.type === "keypress") {
        const unicode = ev.keyCode ? ev.keyCode : ev.charCode;
        if (unicode !== 32 || unicode !== 13) {
            return;
        }
    }

    if (announcerHolder) {
        const message = ev.currentTarget.dataset.srOnlyAnnouncer;
        announcerHolder.innerHTML = "";
        setTimeout(() => {
            announcerHolder.innerHTML = message;
        }, 500);
    }
};

const onloadAnnounce = () => {
    const messageHolder = document.querySelector("[data-sr-onload-announcer]");
    const message = messageHolder && messageHolder.dataset.srOnloadAnnouncer;
    message &&
        setTimeout(() => {
            document.getElementById("sr-only-announcer").innerHTML = message;
        }, 1000);
};

const announcerHandler = () => {
    listEl = document.querySelectorAll("[data-sr-only-announcer]");
    listEl.forEach((el) => {
        el.addEventListener("keypress", startListening);
        el.addEventListener("click", startListening);
    });
};

const observeDOM = function () {
    const MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver;
    return function (obj, callback) {
        if (!obj || obj.nodeType !== 1) {
            return;
        }

      if (MutationObserver) {
          const mutationObserver = new MutationObserver(callback);
          mutationObserver.observe(obj, { childList: true, subtree: false });
          return mutationObserver;
      }
    };
}();

observeDOM(document.body, function (m) {
    let toBeAnnounced = true;
    m.forEach((record) => {
        announcerHandler();
        if (toBeAnnounced) {
            onloadAnnounce();
            toBeAnnounced = false;
        }
    });
});

addEventListener("DOMContentLoaded", () => {
    announcerHandler();
    onloadAnnounce();
    isHeadless();
});

function isHeadless() {
    const headless = sessionStorage.getItem('headless');
    const acceptJavaScript = sessionStorage.getItem('acceptJavaScript');
    const openApiFeatureEnabled = sessionStorage.getItem('openApiFeatureEnabled');

    const footer = document.querySelector('.page-footer-container');
    if (footer !== null) {
        if (headless === 'true' && acceptJavaScript === 'true' && openApiFeatureEnabled === 'true') {
                footer.style.display='none';
        }
    }
}
